import React from 'react'
import { Button } from 'react-bootstrap'
import { Modal } from 'react-bootstrap'
import { BiLoaderCircle } from 'react-icons/bi'
import { useGetPlayerCoinHistoryBlueday } from '../../../../../Hooks/Users/useGetPlayerCoinHistoryBlueday'

interface Props {
    show: boolean
    onHide: () => void
    form: {
        name: string
    }
}

export const PlayerCoinHistoryGanaEnCasa = ({ show, onHide, form }: Props) => {
    const { playerCoinHistory, loading } = useGetPlayerCoinHistoryBlueday({ form })

    const getHistoryColor = (item: any) => {
        // Verificar si es una bonificación basándose en el operation o algún campo específico
        if (item.operation === 'BONUS' || item.operation === 'BONIFICACION') { return 'orange' }

        // Usar el tipo de operación para determinar el color
        if (item.operation === 'INCOME') return 'green'
        if (item.operation === 'OUTCOME') return 'red'
        if (item.operation === 'INCOME_BONUS') return 'orange'

        return 'black' // color por defecto
    }

    const getOperationText = (operation: string) => {
        if (operation === 'OUTCOME') return 'Retiro'
        if (operation === 'INCOME') return 'Ingreso'
        if (operation === 'INCOME_BONUS') return 'Bonificación'
        if (operation === 'BONUS' || operation === 'BONIFICACION') return 'Bonificación'
        return operation
    }


    return (
        <Modal show={show} onHide={onHide}>
            <Modal.Header closeButton>
                <Modal.Title>Historial de cargas/retiros</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {!loading &&
                    <div className="text-primary d-flex justify-content-between mb-3">
                        El usuario {form.name} tiene {playerCoinHistory?.data?.TotalAmount} fichas.
                    </div>
                }

                <div className='text-warning mb-3 d-flex flex-column'>Últimos 30 registros:</div>
                <div className='d-flex justify-content-center'>

                    {loading && <div className='d-flex justify-content-center my-5 gap-2 align-items-center'>
                        <div className='spin-animation d-flex align-items-center justify-content-center'>
                            <BiLoaderCircle size={20} />
                        </div>
                        <span>Cargando...</span>
                    </div>}


                    {!loading &&
                        <div>
                            {playerCoinHistory?.data?.items?.map((item: any) => (
                                <div key={item.id}>
                                    <span style={{ color: getHistoryColor(item) }}>
                                        [{new Date(item.createdAt).toLocaleString()}] {item.amount}
                                        <span style={{ color: 'gray' }}> ( {getOperationText(item.operation)} )</span>
                                    </span><br />
                                </div>
                            ))}
                        </div>}

                </div>
            </Modal.Body>
            <Modal.Footer>

                <Button variant="secondary" onClick={onHide}>
                    Cerrar
                </Button>
            </Modal.Footer>
        </Modal>)
}
